<template>
  <!-- 弹出层：国家或地区选择 -->
  <div>
    <!-- 背景遮罩，点击关闭弹出层 -->
    <div class="popup-bg" @click="getCountrieCode"></div>
      <!-- 弹出内容盒子 -->
    <div class="popup-box">
      <!-- 搜索框部分 -->
      <div class="search-title-box">
        <!-- 搜索图标 -->
         <i class="search-img"></i>
          <!-- 搜索输入框，输入时执行onInput方法进行国家或地区筛选 -->
        <input type="text" v-model="value" class="search-input" @input="onInput" placeholder="請輸入關鍵字">
      </div>
        <!-- 国家或地区列表 -->
      <div class="search-content-box">
        <div class="search-content">
          <!-- 循环显示国家或地区列表 -->
          <div class="search-list" v-for="(item, key, index) in countriesArray" :key="index" @click="getCountrieCode(item)">
            <!-- 国家或地区名和国旗 -->
            <div class="search-list-left">
              <!-- 国旗 -->
              <div class="iti-flag" :class="[key]"/>
                <!-- 国家或地区名 -->
              <div class="search-list-text">{{ item['name'] }}</div>
            </div>
              <!-- 国家或地区电话区号 -->
            <div class="search-list-text">+{{item['dialCode']}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import countryList from './country-list.js' // 导入国家列表数据

  export default {
      components: {
      },
      data() {
          return {
              countriesArray: [], // 国家列表数组
              value: '', // 搜索框的值
              countryAreaList:[]
          }
      },
      props:{
        AreaCodeList:[]
      },
      computed:{
        searchKeywords(){
          return keywords
        }
      },
      created() {

          // 为每个国家添加搜索值，包括国家名和电话区号
          let AreaCodeList=this.AreaCodeList;
          let countryListView2={},countryListView={};
          for (let item in countryList) {
              let searchval = countryList[item].name.toLowerCase() + "@" + countryList[item].dialCode;
              countryList[item].searchval = searchval;
              if(AreaCodeList.length>0){

              }
          }
          if(AreaCodeList.length>0){
            AreaCodeList.forEach((el,index)=>{
              for (let item in countryList) {
                if(countryList[item].dialCode==el){
                  countryListView2[item]=countryList[item];
                }
              }
            })
            countryListView=countryListView2;
            console.log(AreaCodeList)
            console.log(countryListView2)
          } else{
            countryListView=countryList;
          }
          this.countryAreaList=countryListView;
          this.countriesArray = countryListView; // 初始化国家列表

      },
      methods: {
          // 选择国家后的操作
          getCountrieCode(item) {
            this.$emit('getCountrieCode', item) // 触发父组件事件，传递所选国家的信息
          },
          // 搜索框输入时的操作
          onInput() {
            // 根据输入的值筛选国家列表
            let countries=this.countryAreaList;
            if(this.value) {
                let countriesArray = JSON.parse(JSON.stringify(countries));
                this.countriesArray = {};
                for (const item in countriesArray) {
                    if (countriesArray[item]['searchval'].indexOf(this.value) > -1) {
                        this.countriesArray[item] = countriesArray[item]
                    }
                }
            } else {
                this.countriesArray = countries; // 如果输入框为空，则显示完整的国家列表
            }
          }
      }
  }
</script>

<style lang="less" scoped>
  /* // 弹出层样式 */
  .popup-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.5);
    z-index: 9998;
  }
  /* // 内容盒子样式 */
  .popup-box {
    position: absolute;
    z-index: 9999;
    top: 0;
    width: 100%;
    background: #fff;
    border-radius: 10px;
    padding-bottom: 14px;
    color:#606060;
    border: 1px solid #DCDFE6;
  }
  /* // 搜索框样式 */
  .search-title-box {
    background-color:#fff;
    margin: 12px auto;
    width: 95%;
    height: 36px;
    line-height: 36px;
    text-align: left;
    border-radius: 4px;
    display: flex;
    align-items: center;
    color:#606060;
    border: 1px solid #DCDFE6;
    .search-img {
      width: 36px;
      height: 36px;
      margin-right: 5px;
      background-size: 60% auto;
      background-repeat: no-repeat;
      background-position: center center;
      background-image: url(/static/search.png);
      text-align: center;
      color:#606060;
    }
    .search-input {
      flex: 1;
      font-size: 14px;
      background: transparent;
      box-shadow: none;
      height: 36px;
      border: 0;
      &::placeholder{
        color: #606060;
      }
    }
  }
  /* // 国家或地区列表样式 */
  .search-content-box{
    padding: 0 10px;
  }
  .search-content {
    max-height: 180px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 4px;
      height: 1px;
      border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 2px;
      box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
      background:var(--scrollbar-bg-);
    }
    .search-list {
      margin: 5px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      cursor: pointer;
      &:hover{
        background:var(--hover-bg-);
      }
    }
    .iti-flag {
      margin-right: 6px;
    }
    .search-list-text {
      text-align: left;
    }
    .search-list-left {
      display: flex;
      align-items: center;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/country-intl/country-flag.vue